import { render, staticRenderFns } from "./ProgramAwardConfigurationTab.vue?vue&type=template&id=23547115&scoped=true&"
import script from "./ProgramAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProgramAwardConfigurationTab.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ProgramAwardConfigurationTab.vue?vue&type=style&index=0&id=23547115&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23547115",
  null
  
)

export default component.exports